import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Context, Hooks, Platform } from "@xt/xtbase";
import cs from "./index.module.less";
import VipLevel from "./vipLevel";
import RateTable from "./rateTable";
import { getAssetAvgPosition } from "@/api/xt-report";
import { getUserTradeValue } from "@/api/xt-report-stream";
import { getVipInfo, getNormalVipList } from "@/api/xt-user";
import { getStepRates, getUserStepRate } from "@/api/v4/futures";
import { VipInfoObj, FuVipInfoObj } from "./common";
import TitleBg from "@/assets/images/rate/Vector.svg";
const { XtContext } = Context;
const { useTranslation } = Hooks;

const Rate: React.FC = () => {
    const t = useTranslation();
    const [appState] = useContext<any>(XtContext);
    const { loginStatus } = appState;
    const isLogin = loginStatus === 1;
    const isInApp = Platform.isInApp();
    const headerOptions = { headers: { device: isInApp ? "app" : "web" } };

    useEffect(() => {
        if (window)
            window["xt_h5"] = (dataStr) => {
                const { type } = JSON.parse(dataStr);
                if (type === "userLogin") return window.location.reload();
            };
    }, []);

    const vInfoObj = new VipInfoObj(null);
    const [vipInfo, setVipInfo] = useState<typeof vInfoObj>(vInfoObj);
    const [vipList, setVipList] = useState<typeof vInfoObj[]>([]);
    const initNormalVip = async () => {
        let vList = vipList;
        if (vList.length <= 0) {
            const res = await getNormalVipList();
            vList = Array.isArray(res) ? res.map((v) => {
                return new VipInfoObj(v);
            }): [];
            setVipList(vList);
        }
        
        if (!isLogin) return;
        const vipInfoRes = await getVipInfo(headerOptions);
        const vInfo = new VipInfoObj(vipInfoRes);
        vInfo.setTradeVolume = "--";
        vInfo.setXtVolume = "--";
        let curIndx = vList.findIndex((v: typeof vInfoObj) => {
            return v.curLevelNum === vInfo.curLevelNum;
        });
        // if (curIndx < 0) return;
        if (curIndx === vList.length - 1) {
            vInfo.setNormalVip = false;
        } else {
            // vInfo.setNormalVip = true;
            if (curIndx > -1) {
                const { curLevelName, tradeVolume, makerFeeRate, takerFeeRate, xtVolume } = vList[curIndx + 1];
                vInfo.setNextLevelName = curLevelName || "--";
                vInfo.setTradeVolume = tradeVolume;
                vInfo.setXtVolume = xtVolume;
                vInfo.setNextLevelMakerRate = makerFeeRate;
                vInfo.setNextLevelTakerRate = takerFeeRate;
            }
            
            try {
                const userTradeRes = await getUserTradeValue(headerOptions);
                vInfo.setUserTradeValue = +userTradeRes.tradeVolume;
            } catch (error) {
                console.log(error);
            }
            try {
                const xtAvgRes = await getAssetAvgPosition({params: {coinId: 128}, headerOptions});
                vInfo.setUserXtVolume = +xtAvgRes;
            } catch (error) {
                console.log(error);
            }
        }
        setVipInfo(vInfo);
    };

    const fuvInfoObj = new FuVipInfoObj(null);
    const [fuVipInfo, setFuVipInfo] = useState<typeof fuvInfoObj>(fuvInfoObj);
    const [fuVipList, setFuVipList] = useState<typeof fuvInfoObj[]>([]);
    const initFutureVip = async () => {
        
        let fvList = fuVipList;
        if (fvList.length <= 0) {
            const res = await getStepRates(headerOptions);
            fvList = Array.isArray(res) ? res.map((v) => {
                return new FuVipInfoObj(v);
            }) : [];
            setFuVipList(fvList);
        }
        if (!isLogin) return;
        const fuVipRes = await getUserStepRate(headerOptions);
        const fInfo = new FuVipInfoObj(fuVipRes);
        const levelNum = +fInfo.discountLevel;
        fInfo.setLevelName = "--";
        
        if (fvList?.length && !fInfo.specialType) {
            fInfo.setLevelName = levelNum < fvList.length ? fvList[levelNum].stepName : fvList[fvList.length - 1].stepName;
            fInfo.setNextLevelName = levelNum+1 < fvList.length ? fvList[levelNum + 1].stepName : fvList[fvList.length - 1].stepName;
        }
        setFuVipInfo(fInfo);

    };

    useEffect(() => {
        // initNormalVip();
        // initFutureVip();
    }, [isLogin]);

    return (
        <div className={cs.main}>
            <div className={cs.container}>
                {/* 1. 合约交易率 */}
                <section className={cs.section}>
                    {/* <div className={cs.sectionTitleRow}>
                        <div className={cs.sectionIcon} style={{ backgroundImage: `url(${TitleBg})` }} />
                        <h2 className={cs.sectionTitle}>{t("rate.contractTradingRate")}</h2>
                    </div> */}
                    <div className={cs.sectionBody}>
                        <VipLevel vipInfo={vipInfo} fuVipInfo={fuVipInfo} rateType={1} fuVipList={fuVipList} />
                    </div>
                </section>

                {/* 2. 充提费率 + 3. 提现限额 */}
                <RateTable
                    layout="singlePage"
                    vipList={vipList as []}
                    fuVipList={fuVipList as []}
                    rateType={1}
                />
            </div>
        </div>
    );
};

export default observer(Rate);
